import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { MoreFilters } from './MoreFilters';
import { Location } from './Location';
import { Attributes } from './Attributes';
import { Primary } from './Primary';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2
};

const theme = createTheme({
    typography: {
        fontFamily: "Archivo, sans-serif;",
    },
});

export default function FiltersModal({count, handelSubmit, Filters, updateState, handelReset, open, setOpen, autofillData}) {
    const [tabIndex, setTabIndex] = React.useState(0);
    
    const handleClose = () => setOpen(false);

    const handelTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <ThemeProvider theme={theme}>
            <ScopedCssBaseline>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>

                            <section className="filter-header">
                                <div className="filter-container">
                                    <h2>
                                        Filters
                                    </h2>
                                    <i onClick={handleClose} size="26" color="#1C1C1C">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="#1C1C1C" width="26" height="26" viewBox="0 0 20 20" aria-labelledby="icon-svg-title- icon-svg-desc-" role="img" className="close-icon"><title>cross</title><path d="M11.42 10.42l3.54-3.54c0.38-0.4 0.38-1.040 0-1.42s-1.020-0.4-1.42 0l-3.54 3.54-3.54-3.54c-0.4-0.4-1.020-0.4-1.42 0s-0.38 1.020 0 1.42l3.54 3.54-3.54 3.54c-0.38 0.38-0.38 1.020 0 1.42 0.2 0.18 0.46 0.28 0.72 0.28s0.5-0.1 0.7-0.28l3.54-3.56 3.54 3.56c0.2 0.18 0.46 0.28 0.72 0.28s0.5-0.1 0.7-0.28c0.38-0.4 0.38-1.040 0-1.42l-3.54-3.54z"></path></svg>
                                    </i>
                                </div>
                            </section>

                            <section>
                                <article className='filter-main'>
                                    <section className="filter-tabs-wrapper">
                                        <section className="filter-tab-container">
                                            <Tabs
                                                indicatorColor="secondary"
                                                orientation="vertical"
                                                value={tabIndex}
                                                centered={false}
                                                onChange={handelTabChange}
                                                aria-label="Vertical tabs example"
                                            >
                                                {/* inside icon there is filter count, that will show number of filters currently applied */}
                                                <Tab iconPosition='end' icon={<div className='filter-count'>{count.Attributes}</div>} label="Exclude" {...a11yProps(1)} />
                                                <Tab iconPosition='end' icon={<div className='filter-count'>{count.Primary}</div>} label="Status" {...a11yProps(0)} />
                                                <Tab iconPosition='end' icon={<div className='filter-count'>{count.Location}</div>} label="Location/Client" {...a11yProps(2)} />
                                                <Tab iconPosition='end' icon={<div className='filter-count'>{count.More}</div>} label="More filters" {...a11yProps(3)} />
                                            </Tabs>
                                        </section>
                                    </section>
                                    <section className='filter-right-side'>
                                        <TabPanel value={tabIndex} index={0}>
                                            <Attributes autoFill={autofillData} filters={Filters} updateState={updateState}/>
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={1}>
                                            <Primary filters={Filters} updateState={updateState}/>
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={2}>
                                            <Location autoFill={autofillData} filters={Filters} updateState={updateState} />
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={3}>
                                            <MoreFilters filters={Filters} updateState={updateState} />
                                        </TabPanel>
                                    </section>
                                </article>
                            </section>

                            <section className='filter-modal-footer'>
                                <div className='filter-button-container'>
                                    <Button onClick={handelReset} variant="outlined">Reset</Button>
                                    <Button onClick={() => handelSubmit(Filters)} variant="contained">Apply</Button>
                                </div>
                            </section>
                        </Box>
                    </Fade>
                </Modal>
            </ScopedCssBaseline>
        </ThemeProvider>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: {xs: 2, md: 3}, pt: {xs: 0.5, md: 1} }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}